import { useEntityScope } from './useEntityScope.js';
import { visibleNavItems } from '../lib/navItems.js';

export function useNavItems() {
  return visibleNavItems(useEntityScope());
}
